import { FC } from 'react';
import {
  Navigate, RouteProps, Outlet,
} from 'react-router-dom';
import PageRouteEnum from '../../enums/PageRouteEnum';
import { IUserContext } from '../../contexts/UserContext';
import AuthorizedLayout from '../../layouts/AuthorizedLayout';

type TAuthenticatedRouteParams = RouteProps & Pick<
  IUserContext, 'isAuthenticated' | 'masterPasswordSet' | 'twoFactorSet' | 'loginVerified'
> & {
  withLayout: boolean;
}

const AuthenticatedRoute: FC<TAuthenticatedRouteParams> = (
  props: TAuthenticatedRouteParams,
) => {
  const {
    isAuthenticated,
    masterPasswordSet,
    twoFactorSet,
    loginVerified,
    withLayout,
  } = props;

  if (!isAuthenticated || !masterPasswordSet || !twoFactorSet || !loginVerified) {
    return <Navigate to={PageRouteEnum.Login} />;
  }

  if (withLayout) {
    return (
      <AuthorizedLayout>
        <Outlet />
      </AuthorizedLayout>
    );
  }

  return (
    <Outlet />
  );
};

export default AuthenticatedRoute;
